module.exports = __webpack_public_path__ + "img/placeholder6-opti.b0489c09.png";